var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.theme != 'vtf2020')?_c('NotificationsNhipSong',{attrs:{"user":_vm.user}}):_vm._e(),_vm._v(" "),(_vm.theme == 'vtf2020')?_c('VTF',{attrs:{"user":_vm.user,"urlLogout":_vm.urllogout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }